// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"1bb6eb5a","787":"b8231c92"}[chunkId] + ".chunk.js";
};